<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-manage-container" style="padding: 10px">
    <el-tabs type="border-card" v-model="activity">
      <el-tab-pane label="團體App" name="groupTravel">
        <el-form
          style="margin: 10px"
          :inline="true"
          v-model="travelAllowDaysSettings"
          size="mini"
          v-loading="loading"
        >
          <el-form-item label="領隊可提前登入天數">
            <el-input-number
              v-model="travelAllowDaysSettings.leader"
              :min="0"
              :max="100"
              label="請輸入領隊天數"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="旅客可提前登入天數">
            <el-input-number
              v-model="travelAllowDaysSettings.travelers"
              :min="0"
              :max="100"
              label="請輸入旅客天數"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="資料刪除天數">
            <el-input-number
              v-model="travelAllowDaysSettings.delete"
              :min="0"
              :max="50"
              label="請輸入資料刪除天數"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="網卡運送機場費用">
            <el-input-number
              v-model="travelAllowDaysSettings.networkPostFee"
              :min="0"
              label="請輸入網卡運送機場費用"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="足跡景點半徑(公尺)">
            <el-input-number
              v-model="travelAllowDaysSettings.viewPointRadius"
              :min="1"
              :max="1000"
              label="請輸入足跡景點半徑(公尺)"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="旅客報到半徑(公尺)">
            <el-input-number
              v-model="travelAllowDaysSettings.travelerCheckInRadius"
              :min="1"
              label="請輸入旅客報到半徑(公尺)"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="科威API開放期限">
            <el-date-picker
              v-model="travelAllowDaysSettings.coWellStartDate"
              type="date"
              placeholder="請選擇開始日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="至">
            <el-date-picker
              v-model="travelAllowDaysSettings.coWellEndDate"
              type="date"
              placeholder="請選擇結束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="旅客打卡半徑(公尺)">
            <el-input-number
              v-model="travelAllowDaysSettings.checkInRadius"
              :min="1"
              label="請輸入旅客打卡半徑(公尺)"
            ></el-input-number>
          </el-form-item>

          <!-- <el-form-item label="儲存"> -->
          <el-form-item label="">
            <el-button size="mini" @click="saveData" type="success">儲存</el-button>

            <el-button
              style="cursor: pointer"
              :loading="loading"
              type="primary"
              icon="el-icon-refresh-left"
              circle
              @click="fetchData()"
            ></el-button>
          </el-form-item>
        </el-form>

        <div>
          <el-table v-loading="loading" border height="500" :data="list" stripe style="width: 100%">
            <el-table-column prop="date" label="項次" width="50">
              <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="date" label="日期" width="180">
              <template slot-scope="scope">{{ scope.row.buildDate }}</template>
            </el-table-column>
            <el-table-column prop="date" label="內容" width="1200">
              <template slot-scope="scope">{{ scope.row.jsonData }}</template>
            </el-table-column>
            <el-table-column prop="date" label="異動者" width="80">
              <template slot-scope="scope">{{ scope.row.buildUserID }}</template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { MessageBox, Message } from 'element-ui'

import {
  getTravelAppAllowLoginDays,
  setTravelAppAllowLoginDays,
  getSettingModifyRecord,
} from '@/api/travel'

export default {
  name: 'AppManageSettings',

  data() {
    return {
      list: [],
      activity: 'groupTravel',
      loading: false,
      travelAllowDaysSettings: {
        leader: null,
        travelers: null,
        delete: null,
        networkPostFee: null,
        viewPointRadius: null,
        travelerCheckInRadius: null,
        coWellStartDate: null,
        coWellEndDate: null,
        checkInRadius: null,
      },
    }
  },
  async created() {
    await this.getList()
    this.fetchData()
  },
  methods: {
    async getList() {
      this.loading = true
      let resp = await getSettingModifyRecord()
      this.list = resp.data
      this.loading = false
    },
    async fetchData() {
      this.loading = true
      let resp = await getTravelAppAllowLoginDays()
      this.travelAllowDaysSettings = resp.data
      this.loading = false
    },
    async saveData() {
      if (!confirm(`確定儲存設定?`)) {
        return
      }
      this.loading = true

      try {
        let resp = await setTravelAppAllowLoginDays(this.travelAllowDaysSettings)
        await this.getList()
        await this.fetchData()

        Message({
          message: `設定處理完成。`,
          type: 'success',
          duration: 3 * 1000,
        })
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    handleDownload() {},
  },
}
</script>

<style></style>
